<template>
  <cs-preloader-overlay :loading="loading">
    <div id="paymantAmount">
      <div id="aperture"></div>
      <div v-if="subscription" id="warp" class="wide">
        <div class="wrap-container">
          <div :class="$style.header">
            <project-header
              :project="subscription"
              :language="getLanguage"
            />
          </div>

          <div class="container wrap-box">
            <div class="comment separate secure-card">
              <p
                v-word-break="'break-word'"
                v-html="$t('enter.password.from.receipt')"
              ></p>
            </div>

            <form autocomplete="off">
              <InputSecurePass
                ref="InputSecurePass"
                @fieldsAreFilled="checkFile(password)"
                @passwordChangeHandler="password = $event"
              />
              <div class="payment-amount">
                <button
                  :disabled="!isValid"
                  @click.prevent="checkFile"
                >{{ $t('common.proceed') }}</button>
              </div>
            </form>

            <FooterSection />
          </div>
        </div>
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

// import logrocket from '@/services/logrocket';
import HTTPService from '@/services/Http';

import ProjectHeader from 'organisms/project/ProjectHeader';
import InputSecurePass from '@/components/inputs/InputSecurePass';

export default {
  name: 'SubscriptionSecure',
  components: {
    ProjectHeader,
    InputSecurePass,
  },
  created() {
    this.loadContent();
  },
  data() {
    return {
      loading: false,
      password: ['', '', '', ''],
      subscription: null,
    };
  },
  computed: {
    isValid() {
      return this.password.every(el => el);
    },
    paymentId() {
      return this.$route.params.id;
    },
    accessToken() {
      return this.$route.query.token;
    },
    passwordCard() {
      return this.password.join('');
    },
    ...mapState(['TRANSACTION']),
    ...mapGetters(['getLanguage']),
  },
  methods: {
    async loadContent() {
      this.loading = true;

      try {
        const { data } = await HTTPService.fetchSubscription(this.paymentId, this.accessToken);
        this.CLEAR_ALL_STATE();
        this.subscription = data;
        this.SET_TRANSACTION(data);

        await this.GET_PROJECT_LOCALE({ publicId: this.paymentId });
      } catch (error) {
        // logrocket.logger(error);
        this.$router.push({ name: 'service.error' });
      }

      this.loading = false;
    },
    checkFile(password) {
      if (password) {
        this.password = password;
      }

      if (!this.isValid) {
        return false;
      }

      const requestData = {
        paymentId: this.paymentId,
        password: this.passwordCard,
        token: this.accessToken,
      };

      HTTPService.subscriptionAccess(requestData)
        .then(() => {
          sessionStorage.setItem('paymentId', requestData.paymentId);
          sessionStorage.setItem('passwordCard', requestData.password);
          sessionStorage.setItem('accessToken', requestData.token);

          this.$router.push({ name: 'Subscription' });
        })
        .catch(() => {
          this.$alert({
            type: 'danger',
            title: 'check.last.four.numbers',
          });
        });
    },
    ...mapActions(['GET_PROJECT_LOCALE']),
    ...mapMutations(['CLEAR_ALL_STATE', 'SET_TRANSACTION']),
  },
};
</script>

<style lang="sass" module>
  .header
    width: 100%
    padding: 30px 0

    +respond-to('medium')
      padding: 40px 0
</style>

<style lang="sass" scoped>
  .secure-card
    display: flex
    margin-bottom: 2rem !important
    p
      padding-right: 1.4rem
    &::after
      content: ''
      width: 2.42rem
      min-width: 3rem
      height: 3rem
      flex-grow: 1
      background: url('~@/assets/images/icon-secure-card.svg') center center / contain no-repeat
</style>
